import { useMutation, useQueryClient } from '@tanstack/react-query'
import { FeatureFlagService } from '../service/Admin.featureFlagService'
import { toast } from '@app/components/ui/Toast/toast'
import type {
  UpdateFeatureFlagRolesRequest,
  UpdateFeatureFlagRolesResponse,
  FeatureFlagManageResponse,
} from '@app/types'

export const useUpdateFeatureFlagRoles = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: UpdateFeatureFlagRolesRequest) =>
      FeatureFlagService.updateFeatureFlagRoles(data),
    onSuccess: (updatedFlag: UpdateFeatureFlagRolesResponse) => {
      // Update only the specific feature flag in the cache
      queryClient.setQueryData<FeatureFlagManageResponse>(
        ['admin-feature-flag-roles'],
        (oldData) => {
          if (!oldData) return [updatedFlag]

          const flagExists = oldData.some((flag) => flag.feature === updatedFlag.feature)

          if (flagExists) {
            // Update existing flag
            return oldData.map((flag) =>
              flag.feature === updatedFlag.feature
                ? { feature: updatedFlag.feature, user_roles: updatedFlag.user_roles }
                : flag,
            )
          } else {
            // Add new flag
            return [...oldData, updatedFlag]
          }
        },
      )
      toast({
        description: 'Feature flag roles updated successfully',
        type: 'success',
      })
    },
    onError: () => {
      toast({
        description: 'Failed to update feature flag roles',
        type: 'error',
      })
    },
  })
}
